/* eslint-disable */
import { Badge, Tabs } from 'antd';

import { getLabel } from '../../clientUtils';

const StatusTabs = ({ data, onClick, disabled, status }) => {
  if (!Array.isArray(data)) {
    return;
  }

  const items = data.map((item) => ({
    key: item.state,
    label: (
      <span>
        {getLabel(item?.state ?? item?.status)}
        {item?.count > 0 ? (
          <Badge
            className="badge_filter"
            color="#F0F0F0"
            count={item.count}
            overflowCount={1000}
            style={{ marginLeft: '8px' }}
          />
        ) : null}
      </span>
    ),
    disabled
  }));

  return (
    <>
      {items && items.length > 0 ? (
        <Tabs
          activeKey={status}
          defaultActiveKey="ALL"
          items={items}
          onChange={onClick}
          style={{ marginLeft: '16px' }}
        />
      ) : null}
    </>
  );
};

export default StatusTabs;
